import { render } from "./BehaviourProgram.vue?vue&type=template&id=0d8789fb&scoped=true"
import script from "./BehaviourProgram.vue?vue&type=script&lang=js"
export * from "./BehaviourProgram.vue?vue&type=script&lang=js"

import "./BehaviourProgram.vue?vue&type=style&index=0&id=0d8789fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8789fb"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QPopupProxy});
